import React from 'react';
import { cn } from '../../lib/utils';

const Button = React.forwardRef(
  (
    {
      children,
      className,
      variant = 'dark',
      size = 'default',
      icon,
      disabled = false,
      type = 'button',
      isDark = false,
      ...props
    },
    ref
  ) => {
    const baseStyles = 'inline-flex items-center justify-center gap-[6px] rounded-[12px] font-semibold text-[14px] sm:text-[16px] transition-colors focus:outline-none disabled:opacity-50 disabled:pointer-events-none border-0 cursor-pointer';

    const variants = {
      dark: 'bg-button-dark text-white hover:bg-button-dark/90 focus:ring-button-dark',
      primary: 'bg-app-primary text-white hover:bg-app-primary/90 focus:ring-app-primary',
      green: 'bg-app-green text-white hover:bg-app-green/90 focus:ring-app-green',
      outline: 'border border-black bg-white text-black hover:bg-gray-50 focus:ring-black',
      ghost: 'bg-transparent text-black hover:bg-gray-100 focus:ring-gray-400',
      orange: isDark 
        ? 'bg-[#cd6d2c] text-[#000000] hover:bg-[#ffffff]' 
        : 'bg-[#cd6d2c] text-white hover:bg-[#072837]',
    };

    const sizes = {
      default: 'px-4 py-3',
      sm: 'px-3 py-2 text-sm',
      lg: 'px-4 py-3 text-lg',
    };

    return (
      <button
        ref={ref}
        type={type}
        disabled={disabled}
        className={cn(
          baseStyles,
          variants[variant],
          sizes[size],
          className
        )}
        {...props}
      >
        {icon}
        {children}
      </button>
    );
  }
);

Button.displayName = 'Button';

export { Button };
